import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'

class Price extends PureComponent {
    render() {
        return (
            <span className={`price ${this.props.className}`}>
                {displayPrice(this.props.amount)} kr
            </span>
        )
    }
}

Price.propTypes = {
    amount: PropTypes.number.isRequired,
    className: PropTypes.string,
}

export const displayPrice = (number) => {
    const location = process.env.AH_COUNTRYCODE
    const num = parseFloat(number)

    switch (location) {
        case 'SE':
        case 'NO':
            return num.toFixed(2).split('.').join(',')
        default:
            return num.toFixed(2)
    }
}

export default Price
